import * as React from 'react';
import styled from "styled-components";
import { colors } from "../colors/color";
import { colorGenerator } from '../colors/colorGenerator';
import { TooltipTheOneWrapper } from '../TooltipTheOne';

type AvatarProps = {
    children?: React.ReactNode,
    size?:string,
    identifier?:string,
    backgroundColor?:string,
    contentColor?:string,
    colorGenerationString?:string,
    selected?:boolean,
    borderColor?:string,
    toolTip?:React.ReactNode,
    onClick?: (identifier:string) => void
};
export function Avatar (props:AvatarProps): JSX.Element
{
    function handleClick() {
        if (props.onClick) {
            if (!props.identifier)
                throw new Error('Avatar onClick requires identifier prop to be set');

            props.onClick(props.identifier);
        }
    }

    let backgroundColor = props.backgroundColor;
    if(props.backgroundColor === undefined)
    {
        if(props.colorGenerationString)
            backgroundColor = colorGenerator.getDarkColorFromString(props.colorGenerationString);
        else
            backgroundColor = colors.avatar.background;
    }

    const avatarComponent = 
        <AvatarWrapper size={props.size || '32px'} 
            selected={props.selected || false}
            backgroundColor={backgroundColor} 
            contentColor={props.contentColor || colors.avatar.text} 
            selectedBorderColor={colors.avatar.selectedBorder}
            borderColor={props.borderColor}
            role={props.onClick ? 'button' : undefined}
            aria-pressed={props.onClick ? (props.selected ? 'true' : 'false') : undefined}
            onClick={handleClick}>

            {props.children}

            {props.onClick &&
                <AvatarWrapperOverlay size={props.size || '32px'} />
            }
        </AvatarWrapper>;

    return (
        <>
            {props.toolTip
                ?   <TooltipTheOneWrapper tooltipContent={props.toolTip}>
                        {avatarComponent}
                    </TooltipTheOneWrapper>

                :   <>{avatarComponent}</>
            }
        </>
    );
}

const AvatarWrapperOverlay = styled.div<{size:string}>`
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    opacity: 0;
    transition: all 0.5s ease;
    width:${props => props.size};
    height:${props => props.size}; 
`;

const AvatarWrapper = styled.div<{ size:string, selected:boolean, backgroundColor:string, contentColor:string, selectedBorderColor:string, borderColor?:string }>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width:${props => props.size};
    height:${props => props.size};
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 50%;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.contentColor};
    box-sizing: border-box;
    border: ${props => props.selected 
        ?   `2px solid ${props.selectedBorderColor}` 
        :   props.borderColor 
            ?   `2px solid ${props.borderColor}`
            :   `2px solid ${props.backgroundColor}` 
    };
    
    &:hover ${AvatarWrapperOverlay} {
        border-radius: inherit;
        cursor: pointer;
        opacity: 1;
    }
`;